export interface WorkScheduleUserModel {
    userId: number;
    workScheduleId: number;
}
